
<template>
  <div class="main">
    <div class="" style="text-align: right">
      <div class="block">
        <el-date-picker
          v-model="m_date_picker"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="on_change"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "",
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "昨天",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
              picker.$emit("pick", [start, end]);
              sessionStorage.setItem("pickerOptions_selected",1);
              sessionStorage.setItem("pickerOptions_selected_name","昨天");
            },
          },
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 0);
              picker.$emit("pick", [start, end]);
              sessionStorage.setItem("pickerOptions_selected",2);
              sessionStorage.setItem("pickerOptions_selected_name","今天");
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
              sessionStorage.setItem("pickerOptions_selected",3);
              sessionStorage.setItem("pickerOptions_selected_name","最近一周");
            },
          },
          {
            text: "最近30天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
              sessionStorage.setItem("pickerOptions_selected",4);
              sessionStorage.setItem("pickerOptions_selected_name","最近30天");
            },
          },
          {
            text: "最近90天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
              sessionStorage.setItem("pickerOptions_selected",5);
              sessionStorage.setItem("pickerOptions_selected_name","最近90天");
            },
          },
        ],
      },
      m_date_picker: null,
      m_on_change: null,

      m_time_type: 0,
      m_time_name: 0,
      m_time_start: null,
      m_time_end: null,
    };
  },
  mounted() {
  
  },
  methods: {
    init(on_change) {
      this.m_on_change = on_change;
    },
    //
    get_time_type() {
      return this.m_time_type;
    },
    //
    get_time_start() {
      return this.m_time_start;
    },
    get_time_end() {
      return this.m_time_end;
    },
    get_time_type_name() {
      return this.m_time_name;
    },

    //
    on_change() {
      this.m_time_name = sessionStorage.getItem("pickerOptions_selected_name");
      this.m_time_type = sessionStorage.getItem("pickerOptions_selected");

      sessionStorage.setItem("pickerOptions_selected",0);
      sessionStorage.setItem("pickerOptions_selected_name","");

      this.m_time_start = this.m_date_picker[0].getTime();
      this.m_time_end = this.m_date_picker[1].getTime();
      if (this.m_on_change != null) {
        let time_start_stamp=(new Date(new Date(new Date(this.m_time_start).toLocaleDateString()).getTime()).getTime())/1000;
        let time_end_stamp=(new Date(new Date(new Date(this.m_time_end).toLocaleDateString()).getTime() +24 * 60 * 60 * 1000 -1).getTime())/1000;
        this.m_on_change(parseInt(time_start_stamp),parseInt(time_end_stamp) , this.m_time_type, this.m_time_name);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ComponentDatePicker.vue